import * as React from "react";

function SvgCo(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 512 336"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M512.001 251.862H0v75.034a8.829 8.829 0 008.828 8.828h494.345a8.829 8.829 0 008.828-8.828v-75.034z"
          fill="#FF4B55"
        />
        <path
          d="M512.001 168H0V9.103A8.829 8.829 0 018.828.275h494.345a8.829 8.829 0 018.828 8.828V168z"
          fill="#FFE15A"
        />
        <path fill="#41479B" d="M0 168h512v83.862H0z" />
      </g>
    </svg>
  );
}

export default SvgCo;
